// extracted by mini-css-extract-plugin
export default {"title":"privacy-policy_title__1gOP2","headings":"privacy-policy_headings__RAa8i","subtitle":"privacy-policy_subtitle__lfe2w"};